import React from 'react'

const HeaderSocial = () => {
    return (
        <div className='home_socials'>
            <a href="https://github.com/pavank0723/" className='home_social_link' target="_blank">
                <i className='uil uil-github-alt'></i>
            </a>

            <a href="https://www.linkedin.com/" className='home_social_link' target="_blank">
                <i className='uil uil-linkedin-alt'></i>
            </a>
            <a href="https://www.instagram.com/pavan_work_0723/" className='home_social_link' target="_blank">
                <i className="uil uil-instagram"></i>
            </a>

            {/* <a href="" className='home_social_link' target="_blank">
                <i className='uil uil-dribbble'></i>
            </a> */}


        </div>
    )
}

export default HeaderSocial